exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-height[data-v-dd074da4]{height:100vh}.flex-center[data-v-dd074da4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.position-ref[data-v-dd074da4]{position:relative}.top-right[data-v-dd074da4]{position:absolute;right:10px;top:18px}.content[data-v-dd074da4]{text-align:center}.title[data-v-dd074da4]{font-size:60px}.links>a[data-v-dd074da4]{color:#636b6f;padding:0 25px;font-size:12px;font-weight:600;letter-spacing:.1rem;text-decoration:none;text-transform:uppercase}.m-b-md[data-v-dd074da4]{margin-bottom:30px;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd074da4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/auth/adminlogin.vue
// module id = +z/u
// module chunks = 0